<template>
  <v-row>
    <i18n path="password-policy-notice" tag="v-col" class="text-center">
      <a class="policy-link" @click.stop="policyDialog = true">
        {{ $t('password-policy-notice-link') }}
      </a>
    </i18n>
    <v-dialog v-model="policyDialog" width="500" scrollable>
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('password-policy') }}</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p class="mt-4">
            {{ $t('password-policy-body-text1') }}
          </p>

          <ul class="policy-list">
            <li>{{ $t('password-policy-body-text2') }}</li>
            <li>{{ $t('password-policy-body-text3') }}</li>
            <li>{{ $t('password-policy-body-text4') }}</li>
            <li>{{ $t('password-policy-body-text5') }}</li>
          </ul>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="policyDialog = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      policyDialog: false,
    };
  },
};
</script>

<style type="text/css" scoped>
.policy-link {
  text-decoration: underline;
}
.policy-list {
  margin-top: 16px;
  padding-left: 20px;
}
</style>
